import {Transport} from "./Transport";
import {Locale} from "./Locale";
import "./ConsentToast.css";

const BX = (window.BX || top.BX);

export class ConsentToast {
	
	static defaults = {
		acceptElement: '[data-action="accept"]',
		transitionDuration: 300,
		cookieExpires: 60 * 60 * 24 * 14,
		config: null,
		transport: {},
	};
	
	constructor(element: HTMLElement, options: Object) {
		this.el = element;
		this.options = Object.assign({}, ConsentToast.defaults, this.el.dataset, options);
		this.locale = new Locale(this.options.locale);
		this.transport = new Transport(this.options.config, this.options.transport);
	}

	start() : void {
		if (this.alreadyGiven()) {
			this.remove();
			return;
		}

		this.show();
	}

	bind() : void {
		this.handleAccept(true);
	}

	unbind() : void {
		this.handleAccept(false);
	}

	handleAccept(dir: boolean) : void {
		const button = this.el.querySelector(this.options.acceptElement);

		button[dir ? 'addEventListener' : 'removeEventListener']('click', this.onAccept);
	}

	onAccept = (evt: MouseEvent) : void => {
		const button: HTMLButtonElement = evt.currentTarget;

		if (button.disabled) { return; }
		button.disabled = true;

		this.hide();
		this.accept();
	}
	
	remove() : void {
		this.el.remove();
		this.el = null;
	}
	
	show() : void {
		this.bind();
		this.animateIn();
	}

	hide() : void {
		this.unbind();
		this.animateOut().then(() => { this.remove(); });
	}

	animateIn() : void {
		this.wrapTransition(() => {
			this.el.classList.add('is--active');
		});
	}

	animateOut() : Promise<void> {
		return this.wrapTransition(() => {
			this.el.classList.remove('is--active');
		});
	}

	wrapTransition(body: () => {}) : void {
		return new Promise((resolve) => {
			this.el.classList.add('transition--process');

			requestAnimationFrame(() => {
				body();

				setTimeout(() => {
					this.el.classList.remove('transition--process');
					resolve();
				}, this.options.transitionDuration);
			});
		});
	}

	async accept() {
		// Согласие запоминаем сразу: посетитель нажал кнопку, баннер не должен вернуться,
		// чем бы ни закончилась отправка в журнал.
		this.markAccept();

		if (!this.options.config.autoSave) {
			return;
		}

		try {
			await this.transport.saveConsent();
		} catch (error) {
			await this.retryWithFreshSessid();
		}
	}

	// На страницах из кеша BX.message('bitrix_sessid') приходит из localStorage и живёт
	// сутки, а сессия на сервере — два часа. Просроченный ключ даёт "Security error",
	// поэтому берём свежий штатным composite_data.php и повторяем отправку один раз.
	async retryWithFreshSessid() : void {
		try {
			const response = await fetch('/bitrix/tools/composite_data.php', {credentials: 'same-origin'});
			const data = await response.json();
			const vars = (data && data.lang) ? data.lang : data;

			if (!vars || !vars.bitrix_sessid) {
				return;
			}

			BX.message({bitrix_sessid: vars.bitrix_sessid});

			await this.transport.saveConsent();
		} catch (error) {
			// Запись в журнал не удалась. Согласие у посетителя уже сохранено.
		}
	}

	alreadyGiven() {
		return BX.getCookie('COOKIES_CONSENT') === 'Y' || localStorage.getItem('COOKIES_CONSENT') === 'N';
	}

	markAccept() : void {
		const options = {
			expires: this.options.cookieExpires,
			path: '/',
			domain: '.kronostime.ru'
		};

		BX.setCookie('COOKIES_CONSENT', 'Y', options);

		// Домен задан боевым, поэтому на стенде и на любом другом хосте браузер
		// такую cookie отбрасывает. Тогда запоминаем согласие на текущем домене.
		if (BX.getCookie('COOKIES_CONSENT') !== 'Y') {
			delete options.domain;
			BX.setCookie('COOKIES_CONSENT', 'Y', options);
		}
	}

	markDecline() : void {
		localStorage.setItem('COOKIES_CONSENT', 'N');
	}
}